import React from 'react';
import { useField } from 'formik';
import NumberFormat from 'react-number-format';
import './NumberField.scss';

export default function NumberField({ fieldName, label, placeholder }) {
  const [field, meta] = useField(fieldName);

  return (
    <div className="form-group" key={field.name}>
      <label className="form-label">{label}</label>
      <div className="number-input">
        <NumberFormat
          type="text"
          allowNegative={false}
          {...field}
          placeholder={placeholder}
          className="form-control"
        />
      </div>
      {meta.touched && meta.error && (
        <div className="input-feedback">{meta.error}</div>
      )}
    </div>
  );
}
